/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener('DOMContentLoaded', () => {
    const countUpElements = document.querySelectorAll('.wp-block-create-block-count-up .number');

    const countUp = (element) => {
        const originalText = element.textContent.trim();
        const hasThousandsSeparator = originalText.includes(',');
        const targetNumber = parseFloat(originalText.replace(/,/g, ''));
        if (isNaN(targetNumber)) return;

        let currentNumber = 0;
        const increment = targetNumber / 100; // Adjust speed by dividing into 100 steps
        const duration = parseInt(element.parentElement.getAttribute('duration')) || 2000; // Total duration in milliseconds
        const interval = duration / 100; // 100 steps

        const counter = setInterval(() => {
            currentNumber += increment;
            if (currentNumber >= targetNumber) {
                currentNumber = targetNumber;
                clearInterval(counter);
            }
            // Format the number conditionally based on the presence of a thousands separator
            element.textContent = hasThousandsSeparator
                ? currentNumber.toLocaleString(undefined, {
                      minimumFractionDigits: targetNumber % 1 !== 0 ? 2 : 0,
                      maximumFractionDigits: 2,
                  })
                : currentNumber.toFixed(targetNumber % 1 !== 0 ? 2 : 0);
        }, interval);
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                countUp(entry.target);
                observer.unobserve(entry.target); // Stop observing after counting up
            }
        });
    });

    countUpElements.forEach((element) => {
        observer.observe(element);
    });
});